import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer row">
      <hr className="hor-line" />
      <div className="col-6 footer-section">
        <span className="coded-by ">
          Coded by{" "}
          <a
            href="https://daria-nahorna.netlify.app/"
            target="_blanket"
            className="social"
          >
            Daria Nahorna
          </a>{" "}
          -{" "}
          <a
            href="https://gitlab.com/darnahorna/react-weather-application"
            target="_blanket"
            className="social"
          >
            source code
          </a>
        </span>
      </div>
      <div className="col-6 footer-social">
        <a
          href="https://www.linkedin.com/in/daria-nahorna-4a39511b0/"
          target="_blanket"
          className="social ps-4"
          title="Daria`s linkedin"
        >
          <i className="fa-brands fa-linkedin fa-xl"></i>
        </a>
        <a
          href="https://www.facebook.com/nahorna.daria"
          target="_blanket"
          className="social ps-4"
          title="Daria`s Facebook"
        >
          <i className="fa-brands fa-facebook fa-xl"></i>
        </a>
        <a
          href="https://www.instagram.com/darnahorna/"
          target="_blanket"
          className="social ps-4"
          title="Daria`s Inst"
        >
          <i className="fa-brands fa-instagram fa-xl"></i>
        </a>
        <a
          href="https://gitlab.com/darnahorna"
          target="_blanket"
          className="social ps-4"
          title="Daria`s GitLab"
        >
          <i className="fa-brands fa-gitlab fa-xl"></i>
        </a>
      </div>
    </div>
  );
}
